import { useContext } from 'react';
import useCallbackAsync from 'hooks/useCallbackAsync';
import PopNotificationsContext from 'providers/PopNotifications/PopNotifications.context';
import { Lead } from 'models/Lead';
import { useTranslation } from 'react-i18next';
import api from 'api';

export default function useConfirmInterest(
  leadId: string,
  enquiryId: string,
  updateLead: (lead: Lead) => void,
) {
  const { popSuccess } = useContext(PopNotificationsContext);

  const { t } = useTranslation();

  const [onConfirmInterest, isLoading] = useCallbackAsync(async () => {
    const {
      data: {
        lead: { numberOfEnabledDocuments },
      },
    } = await api.portfolio.buyer.confirmInterest(leadId);
    const {
      data: { lead },
    } = await api.portfolio.buyer.getBuyingPortfolio(enquiryId);

    popSuccess(
      t('interestConfirmedSuccessfully', {
        count: numberOfEnabledDocuments || 0,
      }),
    );

    updateLead(lead);
  });

  return { isLoading, onConfirmInterest };
}
